import styled from "styled-components";
import AreaSourceNew from "./AreaSourceNew";
import AreaSourceList from "./AreaSourceList";
import { PlaySource } from "type/panel/Panel.type";

type Props = {
  source: PlaySource[];
  onSourceUpdate: Function;
};

const PanelAreaSource = ({ source, onSourceUpdate }: Props) => {
  const newSourceAddHandle = (sourceFields: PlaySource) => {
    onSourceUpdate([...source, sourceFields]);
  };

  const sourceDeleteHandle = (sourceFieldsInd: number) => {
    const nextSource: PlaySource[] = [
      ...source.slice(0, sourceFieldsInd),
      ...source.slice(sourceFieldsInd + 1),
    ];
    onSourceUpdate(nextSource);
  };

  const sourceUpdateHandle = (nextSource: PlaySource[]) => {
    onSourceUpdate(nextSource);
  };

  return (
    <Div>
      <AreaSourceNew onNewSourceAdd={newSourceAddHandle} />
      <ListDiv>
        <AreaSourceList
          source={source}
          onSourceDelete={sourceDeleteHandle}
          onSourceUpdate={sourceUpdateHandle}
        />
      </ListDiv>
    </Div>
  );
};

const ListDiv = styled.div``;

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;

export default PanelAreaSource;
